import styles from './Input.module.css';

const Input = ({ label, error, icon, ...props }) => (
  <div className={styles.wrapper}>
    {label && <label className={styles.label}>{label}</label>}
    <div className={styles.inputWrap}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <input className={`${styles.input} ${error ? styles.hasError : ''} ${icon ? styles.withIcon : ''}`} {...props} />
    </div>
    {error && <span className={styles.error}>{error}</span>}
  </div>
);

export default Input;
